import { InTimeIcon, NearOutTimeIcon, OutTimeIcon, TIcon } from '@acceso/design-system';

enum EDeliveryValues {
  IN_TIME = 'on_time',
  OUT_TIME = 'timeout',
  NEAR_OUT_TIME = 'middle_time',
}

type TDeliveryStateFilter = {
  tooltip: string;
  value: EDeliveryValues;
  color: string;
  icon: TIcon;
};

const DELIVERY_STATES: TDeliveryStateFilter[] = [
  {
    tooltip: 'A tiempo',
    color: '!text-[#147DFF]',
    value: EDeliveryValues.IN_TIME,
    icon: props => <InTimeIcon {...props} />,
  },
  {
    tooltip: 'Fuera de tiempo',
    value: EDeliveryValues.OUT_TIME,
    color: '!text-[#FF4235]',
    icon: props => <OutTimeIcon {...props} />,
  },
  {
    tooltip: 'Cerca de tiempo',
    value: EDeliveryValues.NEAR_OUT_TIME,
    color: '!text-[#FFAC00]',
    icon: props => <NearOutTimeIcon {...props} />,
  },
];

export { EDeliveryValues, DELIVERY_STATES };
export type { TDeliveryStateFilter };
